var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"successContainer"},[_c('div',{staticClass:"title"},[_vm._v("订单提交成功")]),_c('div',{staticClass:"content"},[_vm._v(" 点击前往查看"),_c('span',{staticClass:"orderEnter",on:{"click":_vm.goOrder}},[_vm._v("订单信息")])])])}
var staticRenderFns = []

export { render, staticRenderFns }